import {
  TransfersCommonStepsIds,
  TransfersDepositStepsIds,
  TransfersSendStepsIds,
} from '../../../types';
import { type PageId } from '../../../utils/useTransfersNextStepState.client';

export const getNextPageForGoingBack = (
  currentPageId: PageId,
  hasMultipleNetworks: boolean,
): PageId | undefined => {
  const nextBackPageMapping = {
    [TransfersCommonStepsIds.ChooseAsset]: undefined,
    [TransfersCommonStepsIds.ChooseNetwork]:
      TransfersCommonStepsIds.ChooseAsset,
    [TransfersCommonStepsIds.AssetAndNetworkSummary]: hasMultipleNetworks
      ? TransfersCommonStepsIds.ChooseNetwork
      : TransfersCommonStepsIds.ChooseAsset,
    [TransfersDepositStepsIds.DepositWallet]:
      TransfersCommonStepsIds.AssetAndNetworkSummary,
    [TransfersSendStepsIds.ChooseRecipient]:
      TransfersCommonStepsIds.ChooseAsset,
    [TransfersSendStepsIds.WalletOwnerType]:
      TransfersSendStepsIds.ChooseRecipient,
    [TransfersSendStepsIds.AddNewWallet]: TransfersSendStepsIds.WalletOwnerType,
    [TransfersSendStepsIds.MemoIsMissing]: TransfersSendStepsIds.AddNewWallet,
    [TransfersSendStepsIds.ChooseAmount]: TransfersSendStepsIds.ChooseRecipient,
    [TransfersSendStepsIds.Confirmation]: TransfersSendStepsIds.ChooseAmount,
    [TransfersSendStepsIds.TwoFactorAuth]: TransfersSendStepsIds.Confirmation,
  };

  return nextBackPageMapping[currentPageId];
};
